"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcHybridAppModal = void 0;
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcHybridAppModal = function (_a) {
    var show = _a.show, onHide = _a.onHide, dialogAs = _a.dialogAs, staticBackdrop = _a.staticBackdrop, children = _a.children;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsPrefix: 'aperza-app-modal', dialogClassName: 'aperza-app-dialog', backdropClassName: 'aperza-app-backdrop', backdrop: staticBackdrop ? 'static' : undefined, size: "lg", dialogAs: dialogAs, show: show, onHide: onHide }, children));
};
exports.AcHybridAppModal = AcHybridAppModal;
exports.AcHybridAppModal.displayName = 'AcHybridAppModal';
//# sourceMappingURL=AcHybridAppModal.js.map